export const taskPageEn = {
  myTasksPage: 'My Tasks',
  newTask: 'Create task',
  byPeople: 'Other’s tasks',
  withMe: 'Tasks with me',
  newTaskSuccess: 'Task created successfully',
  createMore: 'Create more',
  gotoTask: 'Go to the task',

  myTasks: 'My tasks',
  privateList: 'Private tasks',
  byMe: 'Assigned by me',

  myTasksHint: 'Tasks assigned to you',
  privateListHint: 'Tasks that are available only to you',
  byMeHint:
    'Tasks that you’ve assigned to others. If somebody reassigns the task it remains in this list',
  taskName: 'Task name',
  taskFor: 'Task for',
  inBoard: 'in board',
  inColumn: 'in column',
  makePrivate: 'Make private',
  makePublic: 'Make available to company',
  noBoard: 'No board',
  notSet: 'not set',

  starHintGroupChat:
    'Make this task starred for yourself. ' +
    'Chat will be pinned in common chat list',

  othersTasks: 'Others tasks',
  byPeopleTab: 'By user',
  byPeopleHint: 'Tasks assigned to other users, grouped by user',
  notAssignedTab: 'Not assigned',
  notAssignedHint: 'Tasks without assigned user',
  starredTab: 'Starred',
  starredHint: 'All tasks marked with star by you',
  expiredTab: 'Expired',
  expiredHint: 'Tasks with expired deadline',

  sortBy: 'Sort by',
  sortManual: 'manual order',
  sortCreateDate: 'creation date',
  sortDeadline: 'deadline',
  sortAssigned: 'assigned user',
  sortAuthor: 'author',
  asc: 'ascending',
  desc: 'descending',
  userNotSet: 'Not specified'
}

export const taskPageRu: typeof taskPageEn = {
  myTasksPage: 'Мои задачи',
  newTask: 'Создать задачу',
  byPeople: 'По людям',
  withMe: 'Задачи со мной',
  newTaskSuccess: 'Задача успешно создана',
  createMore: 'Создать ещё',
  gotoTask: 'Перейти к задаче',

  myTasks: 'Мои задачи',
  privateList: 'Приватные задачи',
  byMe: 'Порученные мной',

  myTasksHint: 'Задачи, назначенные на вас',
  privateListHint: 'Задачи, которые можете видеть только вы',
  byMeHint:
    'Задачи, которые вы назначили на кого-либо. Если другой пользователь переназначит задачу, она всё равно останется в этом списке',
  taskName: 'Название задачи',
  taskFor: 'Задача для',
  inBoard: 'в доске',
  inColumn: 'в колонке',
  makePrivate: 'Доступна для компании. Сделать доступной только себе',
  makePublic: 'Приватная задача. Нажмите, чтобы сделать доступной в компании',
  noBoard: 'Без доски',
  notSet: 'не установлен',

  starHintGroupChat:
    'Пометить чат звездочкой (для себя, коллегам не видно). ' +
    'Чат будет закреплен в общем списке',

  othersTasks: 'Чужие задачи',
  byPeopleTab: 'По людям',
  byPeopleHint: 'Задачи, назначенные на других',
  notAssignedTab: 'Без исполнителя',
  notAssignedHint: 'Задачи, в которых не назначен исполнитель',
  starredTab: 'Избранные',
  starredHint: 'Все задачи, которые вы пометили звёздочкой',
  expiredTab: 'Просроченные',
  expiredHint: 'Все задачи с просроченным дедлайном',

  sortBy: 'Сортировка',
  sortManual: 'ручная',
  sortCreateDate: 'дата создания',
  sortDeadline: 'дедлайн',
  sortAssigned: 'исполнитель',
  sortAuthor: 'автор',
  asc: 'по возрастанию',
  desc: 'по убыванию',
  userNotSet: 'Не установлен'
}
